import { useEffect, useState } from 'react';

import { useStoreDetails } from 'context/store-context';
import getInventory from 'data/get-product-from-inventory';
import type { Product } from 'types';
import type { Iinventory } from 'types/inventory';

const useInventory = (product?: Product) => {
  const [inventoryData, setInventoryData] = useState<Iinventory[]>([]);
  const [availableStock, setAvailableStock] = useState<number | undefined>();
  const [selectedVariantId, setSelectedVariantId] = useState<string | undefined>(product?.variant?.toString());
  const [isLoading, setLoading] = useState<boolean>(false);
  const { id, inventory } = useStoreDetails();

  useEffect(() => {
    const fetchInventoryData = async (productId: string, storeId: string) => {
      setLoading(true);
      try {
        const response = await getInventory(storeId, productId);
        setInventoryData(response);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    if (!product) return;

    if (inventory.enabled) {
      fetchInventoryData(product.id, id);
    }
  }, [product, id, inventory]);

  useEffect(() => {
    if (product && selectedVariantId) {
      setAvailableStock(undefined);
      const productQty = inventoryData?.find((inventory) => inventory.variantId == selectedVariantId)?.quantity;
      setAvailableStock(productQty);
    }
  }, [product, selectedVariantId, inventoryData]);

  return {
    availableStock,
    isLoading,
    setSelectedVariantId
  };
};

export default useInventory;
